import { CUSTOMER_CONTACT_PURPOSE, ICustomerContact } from '../types'
import { FacilityPurpose, IFacilityAddress } from './api'

const findAddressByProp = <K extends keyof IFacilityAddress>(
  addresses: IFacilityAddress[] = [],
  keyName: K,
  value: IFacilityAddress[K]
): IFacilityAddress | undefined => {
  return addresses.find(address => address[keyName] === value)
}

export const findPrimaryAddress = (
  addresses: IFacilityAddress[] = []
): IFacilityAddress | undefined => {
  return findAddressByProp(addresses, 'purpose', FacilityPurpose.facilityPrimary)
}

export const findPrimaryContact = (
  contactsList: ICustomerContact[] = []
): ICustomerContact | undefined => {
  return contactsList.find(c => c?.purpose === CUSTOMER_CONTACT_PURPOSE.FACILITY_PRIMARY)
}
